/* PACKAGES */
import { ReactLenis } from "lenis/react";

const SmoothScrolling = ({ children }) => {
  return (
    <ReactLenis
      root
      options={{
        lerp: 0.075,
        duration: 1.2,
        smoothTouch: true,
        smoothWheel: true,
        wheelMultiplier: 1.15,
        touchMultiplier: 1.5,
        infinite: false,
        orientation: "vertical",
        gestureOrientation: "vertical",
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      }}
    >
      {children}
    </ReactLenis>
  );
};

export default SmoothScrolling;
